export default __webpack_public_path__ + "static/projectOne-477e483843fce6a1aa07e500f489bb7c.jpg";